export const GET_ALL_DOCTOR_LIST_REQUEST = 'GET_ALL_DOCTOR_LIST_REQUEST';
export const GET_ALL_DOCTOR_LIST_SUCCESS = 'GET_ALL_DOCTOR_LIST_SUCCESS';
export const GET_ALL_DOCTOR_LIST_DESKTOP_SUCCESS =
  'GET_ALL_DOCTOR_LIST_DESKTOP_SUCCESS';
export const GET_ALL_DOCTOR_LIST_FAILURE = 'GET_ALL_DOCTOR_LIST_FAILURE';
export const RESET_PAGE_INDEX = 'RESET_PAGE_INDEX';
export const GET_ALL_DOCTOR_SPECIALIST_REQUEST =
  'GET_ALL_DOCTOR_SPECIALIST_REQUEST';
export const GET_ALL_DOCTOR_SPECIALIST_SUCCESS =
  'GET_ALL_DOCTOR_SPECIALIST_SUCCESS';
export const GET_ALL_DOCTOR_SPECIALIST_FAILURE =
  'GET_ALL_DOCTOR_SPECIALIST_FAILURE';
export const DOCTOR_FORM_SAVE_FIELD = 'DOCTOR_FORM_SAVE_FIELD';
export const DOCTOR_FORM_SAVE_FIELD_DESKTOP = 'DOCTOR_FORM_SAVE_FIELD_DESKTOP';

export const SELECT_DOCTOR = 'doctor/SELECT_DOCTOR';

export const RESET_SELECTED_DOCTOR = 'doctor/RESET_SELECTED_DOCTOR';
export const SET_PAGE_INDEX = 'SET_PAGE_INDEX';
